import moment from "moment";
import { EthiopianDateUtil } from "mui-ethiopian-datepicker";

export const getEthiopianDate = (date, delimiter = "-") => {
  try {
    const parsed = moment(date);
    if (!parsed.isValid()) return "";

    const eth = EthiopianDateUtil.toEth(parsed.toDate());
    if (!eth) return "";

    return `${eth.Day}${delimiter}${eth.Month}${delimiter}${eth.Year}`;
  } catch {
    return "";
  }
};
